import { useCallback, useLayoutEffect, useRef } from "react";

/**
 * A function whose identity never changes and that always calls the latest `fn`. Passed to a component
 * protected by `React.memo`, it no longer makes it re-render on every keystroke or SDK event (the
 * assistant's thread, history and side panel). Only for handlers called from events, never during a
 * render: the latest `fn` is taken after the render that defines it.
 */
const useStableCallback = <A extends unknown[], R>(
    fn: (...args: A) => R,
): ((...args: A) => R) => {
    const latest = useRef(fn);
    useLayoutEffect(() => {
        latest.current = fn;
    });
    return useCallback((...args: A) => latest.current(...args), []);
};

export default useStableCallback;
